import React, {Suspense} from "react"
import ReactDOM from "react-dom/client"
import "@refinedev/antd/dist/reset.css"
import "./index.css"
import "./tablet.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import StoreProvider from "./features/StoreProvider"
import "./i18n"
import AuthProvider from "./features/auth/AuthProvider"
import "./utils/dayjs"
import {installStaleAssetRecovery} from "./utils/staleAssetRecovery"

installStaleAssetRecovery()

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
)

const app = (
    <StoreProvider>
        <Suspense fallback={<div className="app-bootstrap-loading" />}>
            <App />
        </Suspense>
        <AuthProvider />
    </StoreProvider>
)

root.render(<React.StrictMode>{app}</React.StrictMode>)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
